





























import { computed, watch, defineComponent } from "vue";
import CdkImageDetailProvider from "./CdkImageDetailProvider.vue";
import CdkNewsItemDetailProvider from "./CdkNewsItemDetailProvider.vue";
import useNewsItem from "@/composition/useNewsItem";

interface Data {
  guid: string;
  token: string;
  textGenres: any[];
  categories: any[];
  showSharingOptions: boolean;
}

export default defineComponent({
  name: "CdkNewsItem",
  props: {
    guid: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    textGenres: {
      type: Array,
      required: false,
      default: () => []
    },
    categories: {
      type: Array,
      required: false,
      default: () => []
    },
    showSharingOptions: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    CdkImageDetailProvider,
    CdkNewsItemDetailProvider
  },
  setup(props: Data, context) {
    const {
      fetchNewsItem,
      filteredCategories,
      filteredTextGenres,
      hasRemoteContent,
      imgSrc,
      loading,
      newsItemDetail,
      status
    } = useNewsItem(context);

    /**
     * Forward tag click event to parent scope
     */
    const tagClick = (payload): void => {
      context.emit("tagClick", payload);
    };

    /**
     * Returns a string with a status message
     */
    const message = computed(() => {
      if (status.value === 404) {
        return `
        Wir bitten um Entschuldigung, der von Ihnen gewählte Inhalt ist noch nicht
        in der Detailansicht verfügbar. Bitte versuchen Sie es in wenigen
        Augenblicken erneut. Falls das nicht helfen sollte, melden Sie sich bitte
        einmal ab- und wieder an.
      `;
      }
      if (status.value === 401) {
        return `
        Wir bitten um Entschuldigung, der Zugfriff auf das Dokument konnte nicht
        gewährleistet werden. Bitte melden sie sich erneut mit ihrer dpa ID bei
        dpa-Select an.
      `;
      }
      return "";
    });
    /**
     * Returns if data is being loaded currently
     */
    const isLoading = computed(() => {
      return loading.value > 0;
    });

    /**
     * Returns the provider component that should be used depending on
     * attachments. To be expanded when further content types are added.
     */
    const contentComponent = computed(() => {
      if (hasRemoteContent.value) {
        return CdkImageDetailProvider;
      }
      return CdkNewsItemDetailProvider;
    });

    /**
     * Fetch news items if guid changes
     */
    watch(
      () => props.guid,
      () => {
        if (props.guid) {
          fetchNewsItem(props.guid);
        }
      },
      { immediate: true }
    );

    return {
      contentComponent,
      fetchNewsItem,
      filteredCategories,
      filteredTextGenres,
      guid: props.guid,
      hasRemoteContent,
      imgSrc,
      isLoading,
      loading,
      message,
      newsItem: newsItemDetail,
      status,
      tagClick
    };
  }
});
